import React from 'react';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/title';

import 'echarts/lib/chart/bar';

import numeral from 'numeral';

/**
 * * 堆叠柱状图
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-09-10 
 * Version: 1.0
 * Modify log:
 */
function IndexComponent(props) {

    const { rem, dataSource } = props;
    console.log(dataSource)
    //环节办理率
    let data = [];
    dataSource.map(item => {
        if (item.zrs && item.zrs != 0) {
            //未办理人数
            let wblrs = item.zrs - item.hjblrs;
            //已办理百分比
            let yblbfb = (item.hjblrs / item.zrs * 100).toFixed(2);
            //未办理百分比
            let wblbfb = (wblrs / item.zrs * 100).toFixed(2);
            data.push({value:item.hjblrs,name:'已缴费\n占比'+yblbfb+'%'})
            data.push({value:wblrs,name:'未缴费\n占比'+wblbfb+'%'})
        }

        return data;
    });

    const option = {
        title: {
            text: '缴费人数统计',
            textStyle: {
                color: '#05ffe3',
                fontSize: 0.18 * rem,
            },
            left: 'center'
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            orient: 'vertical',
            left: 'left'
        },
        series: [
            {
                name: '缴费人数统计',
                type: 'pie',
                radius: '50%',
                color: ['#fcc623', '#01b0f1',],
                title: {
                    fontSize: 0.14 * rem,
                    offsetCenter: [0, '-35%'],
                    color: '#00ffca'
                },
                data: data,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgb(0,0,0,0.5)',
                    }
                }
            }
        ]
    };

    return (
        <div style={{ width: '100%', height: '100%' }}>
            <ReactEchartsCore
                style={{ width: '100%', height: '100%' }}
                echarts={echarts}
                option={option}
                notMerge={true}
                lazyUpdate={true}
            />
        </div>
    )

}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show-gdnh/LeftTopBox/_Pie.js